import { render } from "./HelpCenterBox.vue?vue&type=template&id=43e11892&scoped=true"
import script from "./HelpCenterBox.vue?vue&type=script&lang=js"
export * from "./HelpCenterBox.vue?vue&type=script&lang=js"

import "./HelpCenterBox.vue?vue&type=style&index=0&id=43e11892&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e11892"]])

export default __exports__